'use client';

import { useApiQuery } from '@shared/api-utils';
import { Skeleton } from '@shared/components/shadcn';
import { useClientConfig } from '@shared/utils';
import { useNow, useTranslations } from 'next-intl';
import type { LotteryName } from '../../lottery-purchases/types';
import { getLotteryConfigPath, getNextSellableDrawing } from '../../tippengine/services/lotteryConfig';
import type { LotteryConfig } from '../../tippengine/types';

const DRAWING_CUTOFF_UPDATE_INTERVAL_MS = 60_000;

type HomeStageBannerEyebrowProps = Readonly<{
  lotteryName: LotteryName;
  fallback: string;
  updateInterval?: number;
}>;

function HomeStageBannerEyebrow({ lotteryName, fallback, updateInterval = DRAWING_CUTOFF_UPDATE_INTERVAL_MS }: HomeStageBannerEyebrowProps) {
  const { apiLocale } = useClientConfig();
  const now = useNow({ updateInterval });
  const { data: lotteryConfig, isPending, isError } = useApiQuery<LotteryConfig>(getLotteryConfigPath(lotteryName, apiLocale));
  const tLottery = useTranslations(`lotteries.${lotteryName}`);

  if (isPending) {
    return <Skeleton className="inline-block h-4 w-40" data-testid="home-stage-banner-eyebrow-skeleton" aria-hidden />;
  }

  if (isError) {
    return fallback;
  }

  const closingDate = lotteryConfig ? getNextSellableDrawing(lotteryConfig, now.getTime())?.closingDate : undefined;

  if (closingDate == null) {
    return fallback;
  }

  return tLottery('schedule', { date: new Date(closingDate) });
}

export { DRAWING_CUTOFF_UPDATE_INTERVAL_MS, HomeStageBannerEyebrow };
export type { HomeStageBannerEyebrowProps };
